module.exports = __webpack_public_path__ + "static/media/add-btn-icon.aa9c84f1.svg";